export function checkValidContractAddress(contract: string) {
    return contract.startsWith('0x') ? contract : `0x${contract}`;
}
